/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MenuPublishInput } from '../../models/menu-publish-input';
import { MenuPublishResponse } from '../../models/menu-publish-response';

export interface MenusMenuIdPublishConfigsPost$Params {
  menuId: string;
  'Active-Tenant-Identifier': string;
      body: MenuPublishInput
}

export function menusMenuIdPublishConfigsPost(http: HttpClient, rootUrl: string, params: MenusMenuIdPublishConfigsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<MenuPublishResponse>> {
  const rb = new RequestBuilder(rootUrl, menusMenuIdPublishConfigsPost.PATH, 'post');
  if (params) {
    rb.path('menuId', params.menuId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MenuPublishResponse>;
    })
  );
}

menusMenuIdPublishConfigsPost.PATH = '/menus/{menuId}/publish-configs';
